import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
  DestroyRef,
} from '@angular/core';
import { NavService } from '@app/core/services/nav.service';
import { Toast, ToastService } from '@app/core/services/toast/toast.service';
import { Ag1ButtonComponent } from '../ag1-button/ag1-button.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

/**
 * @deprecated Do not add new instances of this component. Use PrimeNG's 'p-toast' instead.
 */
@Component({
  selector: 'ag1-toast-notification',
  templateUrl: './ag1-toast-notification.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Ag1ButtonComponent, AngularSvgIconModule],
})
export class Ag1ToastNotificationComponent implements OnInit {
  private _destroyRef = inject(DestroyRef);
  private toastService = inject(ToastService);
  navService = inject(NavService);

  toasts: Toast[] = [];

  constructor() {}

  ngOnInit(): void {
    this.toastService
      .getToast()
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((toasts) => {
        this.toasts = toasts;
      });
  }

  closeToast(index: number): void {
    this.toastService.closeToast(index);
  }

  toastStyle(type): string {
    switch (type) {
      case 'success':
        return 'border-l-green-500 bg-green-500/20';
      case 'error':
        return 'border-l-red-500 bg-red-500/20';
      default:
        return 'border-l-french-blue-500 bg-french-blue-500/20';
    }
  }
}
